import {SHOW_HINT, SHOW_POWER_SOURCE_DETAILS, SET_OUTAGE_ID, SET_EVENT_ID, SET_MODAL, SHOW_NEXT_OUTAGE_QUESTION, ADD_POWER_SOURCE_AT_LOCATION, START_GAME, RESUME_GAME, SET_SCREEN, SHOW_GAME_INTRO, REMOVE_ALL_POWER_SOURCE_TYPE, SHOW_NEXT_YEAR_END_QUESTION, DEPRECATE_SOURCE_TYPE, REPAIR_STATION_AT_LOCATION, REMOVE_ALL_DEPRECATED_STATIONS} from "../actions/action";
import {call, put, select, takeEvery} from "redux-saga/effects";
import * as _ from "lodash";
import {AnyAction} from "redux";
import {hideModal, showGameOverModal, showModal} from "../actions/modals";
import {MODALS} from "../reducers/modal";
import {pauseTimer, resetTimer, resumeTimer, startTimer, stopTimer} from "../actions/timer";
import {SCREENS} from "../reducers/screen";
import {setScreen} from "../actions/screens";
import {resetAllPowerSources} from "../actions/powerSources";
import {delay} from "redux-saga";
import {clearAllDamage, setInitialDamage} from '../actions/power-sources/damage';
import Outage from '../../app/screens/game/modals/outage/Outage';
import {getOutages, IOutage, IPowerSource} from '../../data/data';
import {countPowerSources, countPowerSourcesByType, getPowerSources} from '../reducers/powerSources';
import {endYear, resetYear, startYear} from '../actions/calendar/year';
import {clearAllDeprecations, clearDeprecateType, setInitialDeprecate} from '../actions/power-sources/deprecate';
import {resetCorrectAnswerCount} from '../actions/questions/questions';
import {resetEnergyGenerated} from '../actions/mini-game/energyGenerated';
import {allDamagedStationsRepaired} from "../reducers/calendar/isYearAlreadyComplete";
import {getDeprecations} from '../reducers/power-sources/deprecate';
import {removePowerSources} from '../actions/power-sources/removePowerSources';
import {PowerSourceCounts} from '../reducers/savedPowerSourceCounts';

/**
 * handle game events like hints and outages
 */
export default function* handleGameEvents()
{
    // yield takeEvery(SET_SCREEN, onSetScreen);
    yield takeEvery(SHOW_GAME_INTRO, onShowGameIntro);
    yield takeEvery(START_GAME, onStartGame);
    yield takeEvery(RESUME_GAME, onResumeGame);
    yield takeEvery(SHOW_HINT, onShowHint);
    // yield takeEvery(SHOW_NEXT_OUTAGE_QUESTION, onShowOutageQuestion);
    yield takeEvery(SHOW_NEXT_YEAR_END_QUESTION, onShowYearEndQuestion);
    yield takeEvery(SHOW_POWER_SOURCE_DETAILS, onShowPowerSourceDetails);

    yield takeEvery(SET_OUTAGE_ID, onOutageID);
    yield takeEvery(DEPRECATE_SOURCE_TYPE, onDeprecateType);
    yield takeEvery(SET_EVENT_ID, onEventID);
    yield takeEvery(SET_MODAL, onSetModal);

    yield takeEvery(ADD_POWER_SOURCE_AT_LOCATION, onPowerSourceAdded);
    yield takeEvery(REPAIR_STATION_AT_LOCATION, onPowerSourceRepaired);
    yield takeEvery(REMOVE_ALL_DEPRECATED_STATIONS, removeDeprecatedStations);
}


// function* onSetScreen(action: AnyAction)
// {
//     const {payload} = action;
//     const {screen_id} = payload;
//
//
//     switch(screen_id)
//     {
//         case SCREENS.MINI_GAME:
//
//             yield put(openResultsPanel());
//
//             break;
//     }
// }


/**
 * reset the game and show the game intro
 */
function* onShowGameIntro(action: AnyAction)
{
    //  reset all game stuff

    yield put(resetYear());
    yield put(resetTimer());
    yield put(resetAllPowerSources());
    yield put(hideModal());

    //  show the game intro

    yield put(setScreen(SCREENS.GAME_INTRO));
}


/**
 * run game start side effects
 * @param {AnyAction} action
 */
function* onStartGame(action: AnyAction)
{
    yield put(resetYear());
    yield put(resetTimer());
    yield put(resetAllPowerSources());
    yield put(clearDeprecateType());
    yield put(setScreen(SCREENS.GAME));
    yield put(startYear());
    yield put(resetCorrectAnswerCount());
    yield put(resetEnergyGenerated());
}


/**
 * resume the game
 * @param {AnyAction} action
 */
function* onResumeGame(action: AnyAction)
{
    yield put(setScreen(SCREENS.GAME));

    yield call(delay, 2000);

    yield put(startTimer());
}


/**
 * show the hint modal
 * @param {AnyAction} action
 */
function* onShowHint(action: AnyAction)
{
    yield put(showModal(MODALS.HINT));
}


/**
 * show the outage modal
 * @param {AnyAction} action
 */
function* onOutageID(action: AnyAction)
{
    const {payload} = action;
    const {outage_id} = payload;

    // yield put(showModal(_.isEmpty(outage_id) ? null : MODALS.OUTAGE));

    console.group('onOutageID');
    console.log('outage', outage_id);
    console.groupEnd();

    if (! outage_id)
    {
        yield put(clearAllDamage());
    }
    else
    {
        const outages: IOutage[] = getOutages();
        const outage: IOutage = _.find(outages, { id: outage_id });
        const {affects} = outage;
        const power_sources: IPowerSource[] = yield select(getPowerSources);

        const damage: boolean[] = _.map(power_sources, power_source => power_source && _.includes(affects, power_source.id));

        // console.group('onOutageID');
        // console.log('outages', outages);
        // console.log('outage', outage);
        // console.log('affects', affects);
        // console.log('damage', damage);
        // console.groupEnd();

        yield put(setInitialDamage(damage));
    }
}


/**
 * show the outage modal
 * @param {AnyAction} action
 */
function* onDeprecateType(action: AnyAction)
{
    const {payload} = action;
    const {deprecate} = payload;

    // yield put(showModal(_.isEmpty(outage_id) ? null : MODALS.OUTAGE));

    if (! deprecate)
    {
        yield put(clearAllDeprecations());
    }
    else
    {
        const power_sources: IPowerSource[] = yield select(getPowerSources);
        const potential_deprecations: IPowerSource[] = _.filter(power_sources, source => source && source.id === deprecate);


        const counts: PowerSourceCounts = yield select(countPowerSourcesByType);
        const nuclear_count: number = counts['nuclear'];
        const nuclear_deprecate: number = nuclear_count <= 5 ? nuclear_count - 1 : 5;

        const deprecated_sources: IPowerSource[] = _.sampleSize(potential_deprecations, deprecate === 'nuclear' ? nuclear_deprecate : 50);

        const deprecations: boolean[] = _.map(power_sources, source => _.includes(deprecated_sources, source));


        // console.group('onDeprecateType');
        // console.log('power sources', power_sources);
        // console.log('potential_deprecations', potential_deprecations);
        // console.log('deprecated_sources', deprecated_sources);
        // console.log('deprecations', deprecations);
        // console.groupEnd();

        yield put(setInitialDeprecate(deprecations));
    }
}


function* removeDeprecatedStations(action: AnyAction)
{
    const deprecated_sources: boolean[] = yield select(getDeprecations);

    console.group('removeDeprecatedStations');
    console.log('deprecated_sources', deprecated_sources);
    console.groupEnd();

    yield put(removePowerSources(deprecated_sources))
}


/**
 * show the question modal
 * @param {AnyAction} action
 */
function* onShowOutageQuestion(action: AnyAction)
{
    yield call(delay, 500);
    yield put(showModal(MODALS.OUTAGE_QUESTION));
}


/**
 * show the question modal
 * @param {AnyAction} action
 */
function* onShowYearEndQuestion(action: AnyAction)
{
    yield call(delay, 500);
    yield put(showModal(MODALS.YEAR_END_QUESTION));
}


/**
 * show the event details modal
 * @param {AnyAction} action
 */
function* onEventID(action: AnyAction)
{
    yield put(showModal(MODALS.EVENT));
}


/**
 * show the power source details modal
 * @param {AnyAction} action
 */
function* onShowPowerSourceDetails(action: AnyAction)
{
    yield put(showModal(MODALS.POWER_SOURCE_DETAILS));
}


/**
 * pause or resume the time when we show or hide modals
 * @param {AnyAction} action
 */
function* onSetModal(action: AnyAction)
{
    const {payload} = action;
    const {modal_id} = payload;

    yield put(modal_id ? pauseTimer() : resumeTimer());
}


/**
 * when a new power source is added, check the total output
 * @param {AnyAction} action
 */
function* onPowerSourceAdded(action: AnyAction)
{
    yield put(startTimer());
}



/**
 * when a new power source is added, check the total output
 * @param {AnyAction} action
 */
function* onPowerSourceRepaired(action: AnyAction)
{
    const all_repaired: boolean = yield select(allDamagedStationsRepaired);

    if (all_repaired) yield put(endYear());
}


/**
 * when the main game timer expires
 * @param {AnyAction} action
 */
function* onTimerExpired(action: AnyAction)
{
    yield put(stopTimer());
    yield put(showGameOverModal());
}



// WEBPACK FOOTER //
// ./src/ts/store/sagas/handleGameEvents.ts